// A1 — "How MRP One Works" introductory tour. 7 steps over Order Control screen.
export default {
  key: 'A1',
  route: '/ordercontrol',
  steps: [
    {
      id: 'intro',
      target: '[data-tour-id="header.logo"]',
      title: 'Welcome to MRP One',
      desc: 'MRP One connects sales, production planning, execution, and tracking.',
    },
    {
      id: 'inquiries',
      target: '[data-tour-id="menu.inquiries"]',
      title: 'Inquiries',
      desc: 'Sales module for managing customer inquiries.',
    },
    {
      id: 'orders',
      target: '[data-tour-id="menu.orders"]',
      title: 'Orders',
      desc: 'Confirmed customer orders ready for production planning.',
    },
    {
      id: 'products',
      target: '[data-tour-id="menu.products"]',
      title: 'Products',
      desc: 'Product specifications database — reusable across orders and inquiries, with bill-of-materials, raw materials, and manufacturing steps.',
    },
    {
      id: 'workcenters',
      target: '[data-tour-id="menu.workcenters"]',
      title: 'Workcenters',
      desc: 'Tracking and management of production capacity and the resources used to make the products — machines, workstations, and operators.',
    },
    {
      id: 'schedule',
      target: '[data-tour-id="menu.schedule"]',
      title: 'Schedule',
      desc: 'Manufacturing schedule - distributes work automatically across resources based on the prioritiy.',
    },
    {
      id: 'control',
      target: '[data-tour-id="menu.ordercontrol"]',
      title: 'Order Control',
      desc: 'Full real-time visibility into production.',
    },
  ],
}
